import { ToolProviderIdEnum } from '../../../types';
export const TOOL_CONTENT_OVERRIDE_PROVIDER_IDS = [ToolProviderIdEnum.PagerDuty, ToolProviderIdEnum.Opsgenie];
/** Primary content field that falls back to the tool step default `body`. */
export const TOOL_PROVIDER_PRIMARY_CONTENT_KEY = {
    [ToolProviderIdEnum.PagerDuty]: 'summary',
    [ToolProviderIdEnum.Opsgenie]: 'message',
};
export function getToolProviderPrimaryContentKey(providerId) {
    return TOOL_PROVIDER_PRIMARY_CONTENT_KEY[providerId];
}
//# sourceMappingURL=tool-provider-primary-content.js.map